import cookie from 'react-cookies';

import {
  ACCESS_TOKEN_COOKIE,
  WELLITORY_SESSION_COOKIE,
} from './authConstants';

function base64UrlDecode(segment) {
  const padded = segment.replace(/-/g, '+').replace(/_/g, '/');
  const pad = padded.length % 4;
  const base64 = pad ? padded + '='.repeat(4 - pad) : padded;

  if (typeof atob !== 'undefined') {
    try {
      return decodeURIComponent(
        Array.prototype.map
          .call(atob(base64), (c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(''),
      );
    } catch (e) {
      return '';
    }
  }

  return '';
}

/** exp из JWT без верификации подписи (только для клиентской эвристики до запроса) */
export function getJwtExpUnixFromToken(token) {
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }
  try {
    const json = base64UrlDecode(parts[1]);
    const payload = JSON.parse(json);
    return typeof payload.exp === 'number' ? payload.exp : null;
  } catch (e) {
    return null;
  }
}

export function getAccessTokenFromBrowserCookie() {
  return cookie.load(ACCESS_TOKEN_COOKIE) || undefined;
}

/** access_token не httpOnly — сбрасываем сразу в браузере */
export function clearJwtAccessTokenInBrowser() {
  cookie.remove(ACCESS_TOKEN_COOKIE, { path: '/', domain: '.welltory.com' });
  cookie.remove(ACCESS_TOKEN_COOKIE, { path: '/' });
}

export function hasWelltorySessionInBrowser() {
  return Boolean(cookie.load(WELLITORY_SESSION_COOKIE));
}

/**
 * TRANSITION: есть сессия, но нет JWT — нужен obtain-tokens.
 * Удалить после полного перехода на JWT.
 */
export function needsJwtHydrationFromSessionInBrowser() {
  return hasWelltorySessionInBrowser() && !getAccessTokenFromBrowserCookie();
}
